/* Ficha de producto: variantes (precio, tachado, stock, imagen, URL), cantidad con tope de stock,
   Agregar por Ajax (abre el drawer), zoom en <dialog>, miniaturas y copiar enlace. */
(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;
  const form = root.querySelector('[data-product-form]');
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const $ = (s) => root.querySelector(s);
  const idInput = $('[data-variant-id]');
  const qtyInput = $('[data-qty-input]');
  const plus = $('[data-qty-plus]');
  const minus = $('[data-qty-minus]');
  const addBtn = $('[data-add-to-cart]');
  const buyBtn = $('[data-buy-now]');
  const errorEl = $('[data-product-error]');
  const stockEl = $('[data-stock]');
  const priceEl = $('[data-price]');
  const askPrice = $('[data-ask-price]');
  const shopRoot = window.Shopify?.routes?.root ?? '/';

  // Formato de dinero de la tienda (shop.money_format), igual que el filtro `money` de Liquid.
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    const [int, dec] = v.split('.');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: `${group(int, ',')}.${dec}`,
      amount_no_decimals: group(int, ','),
      amount_with_comma_separator: `${group(int, '.')},${dec}`,
      amount_no_decimals_with_comma_separator: group(int, '.'),
      amount_with_apostrophe_separator: `${group(int, "'")}.${dec}`,
    }[key] ?? v));
  };

  let current = variants.find((v) => String(v.id) === idInput.value) ?? variants[0];
  // Precio 0 = sin precio cargado: nunca se muestra "$ 0" ni se puede comprar.
  const sellable = () => current.available && current.price > 0;
  const maxQty = () => (current.tracked ? Math.max(current.qty, 0) : 99);

  function renderStock() {
    stockEl.hidden = current.price <= 0; // sin precio no se habla de stock
    if (stockEl.hidden) return;
    let dot = 'bg-signal-success';
    let text = stockEl.dataset.lOk;
    if (!current.available) { dot = 'bg-lacre-600'; text = stockEl.dataset.lOut; }
    else if (current.tracked && current.qty <= 10) { dot = 'bg-foil-600'; text = stockEl.dataset.lLeft.replace('__N__', current.qty); }
    stockEl.innerHTML = `<span class="w-1.5 h-1.5 rounded-full inline-block ${dot}" aria-hidden="true"></span>`;
    stockEl.append(text);
  }

  function renderQty() {
    const max = maxQty();
    let q = parseInt(qtyInput.value, 10) || 1;
    q = Math.min(Math.max(q, 1), Math.max(max, 1));
    qtyInput.value = q;
    qtyInput.max = max;
    minus.disabled = !sellable() || q <= 1;
    plus.disabled = !sellable() || q >= max;
  }

  const addLabel = () => (current.price <= 0 ? addBtn.dataset.lOnRequest : !current.available ? addBtn.dataset.lOut : addBtn.dataset.lAdd);

  function render() {
    idInput.value = current.id;
    const priced = current.price > 0;
    priceEl.textContent = priced ? money(current.price) : priceEl.dataset.lOnRequest;
    if (askPrice) askPrice.hidden = priced;
    const cmp = $('[data-compare-at]');
    cmp.hidden = !(priced && current.compare > current.price);
    if (!cmp.hidden) cmp.textContent = money(current.compare);
    addBtn.disabled = !sellable();
    buyBtn.disabled = !sellable();
    addBtn.querySelector('[data-label]').textContent = addLabel();
    renderStock();
    renderQty();
    if (current.media) irAMedia(current.media);
  }

  root.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option-index]')) return;
    const chosen = [...root.querySelectorAll('[data-option-index]:checked')].map((i) => i.value);
    const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    if (!match) {
      addBtn.disabled = true;
      buyBtn.disabled = true;
      addBtn.querySelector('[data-label]').textContent = addBtn.dataset.lUnavailable;
      return;
    }
    current = match;
    errorEl.textContent = '';
    render();
    const url = new URL(location.href);
    url.searchParams.set('variant', current.id);
    history.replaceState(null, '', url);
  });

  plus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; renderQty(); });
  minus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; renderQty(); });
  qtyInput.addEventListener('change', renderQty);

  // Los botones de Releasit quedan ocultos: nuestros "Pedir" abren su formulario contraentrega.
  document.head.insertAdjacentHTML('beforeend', '<style>#rsi_buy_now_button{display:none!important}</style>');

  // Agregar por Ajax; "Pedir" abre el formulario de Releasit, o si no cargó, va por enlace de carrito al checkout solo con este producto.
  form.addEventListener('submit', async (e) => {
    if (e.submitter && e.submitter.hasAttribute('data-buy-now')) {
      e.preventDefault();
      if (!sellable()) return;
      const rsi = document.getElementById('rsi_buy_now_button');
      if (rsi) rsi.click();
      else location.href = `${shopRoot}cart/${idInput.value}:${parseInt(qtyInput.value, 10) || 1}`;
      return;
    }
    e.preventDefault();
    if (!sellable()) return;
    const label = addBtn.querySelector('[data-label]');
    addBtn.disabled = true;
    label.textContent = addBtn.dataset.lAdding;
    errorEl.textContent = '';
    try {
      const res = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        errorEl.textContent = data.description || data.message || errorEl.dataset.fallback || '';
      } else {
        dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (_) {
      errorEl.textContent = errorEl.dataset.fallback || '';
    } finally {
      addBtn.disabled = !sellable();
      label.textContent = addLabel();
    }
  });

  // Carrusel: se desliza con scroll-snap; flechas, miniaturas y variantes llevan a su foto.
  const pista = $('[data-carrusel]');
  const slides = pista ? [...pista.querySelectorAll('[data-slide]')] : [];
  const thumbs = [...root.querySelectorAll('[data-thumb]')];
  const contador = $('[data-carrusel-contador]');
  const suave = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  let activo = 0;
  const irA = (i) => pista?.scrollTo({ left: ((i + slides.length) % slides.length) * pista.clientWidth, behavior: suave });
  function irAMedia(id) {
    const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
    if (i >= 0) irA(i);
  }
  pista?.addEventListener('scroll', () => {
    const i = Math.round(pista.scrollLeft / pista.clientWidth);
    if (i === activo) return;
    activo = i;
    thumbs.forEach((t, j) => t.setAttribute('aria-pressed', String(j === i)));
    if (contador) contador.textContent = `${i + 1} / ${slides.length}`;
  }, { passive: true });
  thumbs.forEach((t, i) => t.addEventListener('click', () => irA(i)));
  $('[data-carrusel-prev]')?.addEventListener('click', () => irA(activo - 1));
  $('[data-carrusel-next]')?.addEventListener('click', () => irA(activo + 1));

  // Zoom de la foto que se está viendo.
  const zoom = $('[data-zoom]');
  const zoomOpen = $('[data-zoom-open]');
  if (zoom && zoomOpen) {
    const open = () => {
      const img = $('[data-zoom-img]');
      const slide = slides[activo];
      if (img && slide) {
        img.src = slide.dataset.zoomSrc;
        img.alt = slide.querySelector('img')?.alt ?? img.alt;
      }
      zoom.showModal();
    };
    zoomOpen.addEventListener('click', open);
    pista?.addEventListener('click', open);
    zoom.addEventListener('click', () => zoom.close());
    zoom.addEventListener('close', () => zoomOpen.focus());
  }

  // Copiar enlace.
  const copy = root.querySelector('[data-copy-link]');
  copy?.addEventListener('click', async () => {
    const status = root.querySelector('[data-copy-status]');
    try { await navigator.clipboard.writeText(location.href.split('?')[0]); status.textContent = copy.dataset.lCopied; }
    catch (_) { status.textContent = copy.dataset.lFailed; }
    setTimeout(() => { status.textContent = ''; }, 2000);
  });

  render();
})();

/* Fichas interactivas (snippets/ficha-*.liquid): cada botón explica qué hace, marca su lugar en la foto
   y cambia la vista de ejemplo (encendido, blanco/cálido, efecto, brillo). Los videos reales solo corren en pantalla. */
document.querySelectorAll('[data-ficha]').forEach((ficha) => {
  const preview = ficha.querySelector('[data-ficha-preview]');
  const info = ficha.querySelector('[data-ficha-info]');
  const marker = ficha.querySelector('[data-ficha-marker]');
  let encendida = preview?.dataset.state;
  let brillo = 4;
  ficha.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ficha-btn]');
    if (!btn) return;
    const { state, dim, x, y, punto } = btn.dataset;
    if (preview) {
      const actual = preview.dataset.state;
      let next = actual;
      if (state === 'toggle') next = actual === 'off' ? encendida : 'off';
      else if (state === 'w') next = actual === 'white' ? 'warm' : 'white';
      else if (state) next = state;
      if (dim) {
        brillo = Math.min(4, Math.max(0, brillo + Number(dim)));
        preview.style.setProperty('--brillo', 0.4 + brillo * 0.15);
      }
      preview.dataset.state = next;
      if (next !== 'off') encendida = next;
    }
    info.textContent = btn.dataset.info;
    if (marker && x) {
      // y es % del alto; en cqw (ancho del lienzo) se escala por la proporción de la foto.
      const img = marker.parentElement.querySelector('img');
      const proporcion = img.height / img.width;
      const primera = marker.hidden;
      if (primera) marker.style.transition = 'none';
      marker.style.translate = `calc(${x}cqw - 50%) calc(${y * proporcion}cqw - 50%)`;
      marker.hidden = false;
      if (primera) { marker.getBoundingClientRect(); marker.style.transition = ''; }
    }
    ficha.querySelectorAll('[data-ficha-punto]').forEach((p) => p.toggleAttribute('data-activo', p.dataset.fichaPunto === punto));
    ficha.querySelectorAll('[data-ficha-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
  });
});

// Los videos se repiten: cada uno lleva su botón de pausa (WCAG 2.2.2) y no se reanuda solo si lo pausaron.
const fichaVideos = document.querySelectorAll('[data-ficha-video]');
if (fichaVideos.length) {
  // Pósters diferidos: no compiten con la foto principal al llegar del anuncio.
  const conPoster = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
    if (isIntersecting) { target.poster = target.dataset.poster; conPoster.unobserve(target); }
  }), { rootMargin: '800px 0px' });
  fichaVideos.forEach((v) => v.dataset.poster && conPoster.observe(v));
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    fichaVideos.forEach((v) => {
      v.controls = true;
      v.parentElement.querySelector('[data-ficha-pausa]')?.remove();
    });
  } else {
    const io = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting && !('pausado' in target.dataset)) target.play().catch(() => {});
      else target.pause();
    }), { threshold: 0.35 });
    fichaVideos.forEach((v) => {
      io.observe(v);
      const btn = v.parentElement.querySelector('[data-ficha-pausa]');
      btn?.addEventListener('click', () => {
        const pausar = !('pausado' in v.dataset);
        v.toggleAttribute('data-pausado', pausar);
        btn.toggleAttribute('data-pausado', pausar);
        btn.setAttribute('aria-label', pausar ? btn.dataset.lReproducir : btn.dataset.lPausar);
        if (pausar) v.pause(); else v.play().catch(() => {});
      });
    });
  }
}

// Barra de secciones: marca la sección que se está leyendo.
const fichaNav = document.querySelector('[data-ficha-nav]');
if (fichaNav) {
  const enlaces = [...fichaNav.querySelectorAll('a[href^="#"]')];
  const marcarSeccion = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
    if (!isIntersecting) return;
    enlaces.forEach((a) => (a.hash === `#${target.id}` ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
  }), { rootMargin: '-45% 0px -50% 0px' });
  enlaces.forEach((a) => { const s = document.querySelector(a.hash); if (s) marcarSeccion.observe(s); });
}

document.querySelectorAll('[data-ficha-comprar]').forEach((b) => b.addEventListener('click', () => {
  document.querySelector('[data-buy-now]')?.click();
}));
